import type { Row } from '@tanstack/react-table'

import { TQrData } from '@/generator/shared'

function toSafeNumber(value: unknown): number {
	const parsed = Number(value)
	return Number.isFinite(parsed) ? parsed : 0
}

export function scansNumericSort(
	rowA: Row<TQrData>,
	rowB: Row<TQrData>,
	columnId: string,
): number {
	const a = toSafeNumber(rowA.getValue(columnId))
	const b = toSafeNumber(rowB.getValue(columnId))
	return a - b
}
